export const updateColumnCalculation = (
  droppedColumnNumber: number,
  totalPersons: number,
): {
  personArrayPosition: number
  droppedDayNumber: number
} => {
  const personArrayPosition: number =
    (droppedColumnNumber + (totalPersons - 1)) % totalPersons
  const droppedDayNumber: number = Math.round(
    droppedColumnNumber / totalPersons,
  )

  return {
    personArrayPosition,
    droppedDayNumber,
  }
}
